<template>
	<div id="modal-common-export-columns">
		<b-modal :id="modalName" hide-footer size="sm">
            <template v-slot:modal-title>
                Export Columns
            </template>

            <b-form-checkbox
                id="checkbox-export-column-select-all"
                v-model="allSelected"
                :value="parseInt(1)"
                :unchecked-value="parseInt(0)"
                >
                    Select All
            </b-form-checkbox>

            <b-table-simple hover small caption-top bordered responsive>
                <b-tbody>
                    <b-tr v-for="field in fields" :key="field.key">
                        <b-td v-if="field.key != 'actions'">
                            <b-form-checkbox
                                :id="'checkbox-export-' + field.key"
                                :value="parseInt(1)"
                                v-model="field.visible"
                                :unchecked-value="parseInt(0)"
                            >
                            </b-form-checkbox>
                        </b-td>
                        <b-td v-if="field.key != 'actions'">
                            <span v-if="field.key == 'thumb'">Thumbnail</span>
                            <span v-else>{{ field.label }}</span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-button type="submit" variant="success" @click="exportColumns">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Exporting...
                </span>
                <span v-else>Export</span>
            </b-button>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'fields',
            'ignores'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-common-export-columns',
                submitting: 0
			}
		},

		methods: {
            exportColumns() {
                let cols = []
                let keys = []
                this.fields.forEach(key => {
                    if (key.visible && !this.ignores.includes(key.key)) {
                        cols.push(key.label)
                        keys.push(key.key)
                    }
                })

                this.closeModal(this.modalName)
                this.$emit('exportExcel', cols, keys)
            }
		},

		computed: {
            allSelected: {
                set (visible) {
                    this.fields.forEach(function (field) {
                        field.visible = visible
                    })
                },
                get () {
                    return 1

                    return this.fields.every(function (field) {
                        return field.visible
                    })
                }
            }
		},

		mounted() {
            // this.updatedFields = Object.assign({}, this.fields)
		}
	}
</script>
<style lang="scss">
    #modal-common-export-columns {
        .modal-dialog {
            width: 250px;
        }
    }
</style>
